import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Navigation
    home: "Home",
    products: "Products",
    courses: "Courses",
    cart: "Cart",
    login: "Login",
    register: "Register",
    logout: "Logout",
    dashboard: "Dashboard",
    profile: "Profile",
    myOrders: "My Orders",
    transactions: "Transactions",
    adminPanel: "Admin Panel",
    
    // Common
    welcome: "Welcome",
    search: "Search",
    searchProducts: "Search products...",
    loading: "Loading...",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    
    // Wallet
    cashWallet: "Cash Wallet",
    commissionWallet: "Commission Wallet",
    addFunds: "Add Funds",
    transfer: "Transfer",
    
    // Orders
    orderPlaced: "Order Placed",
    orderPending: "Pending Approval",
    orderApproved: "Approved",
    orderRejected: "Rejected",
    
    // Confirmation
    confirmPayment: "Confirm Payment",
    confirmPaymentMsg: "Are you sure you want to proceed with this payment?",
    doubleCheck: "Please double check before confirming",
  },
  hi: {
    // Navigation
    home: "होम",
    products: "उत्पाद",
    courses: "कोर्स",
    cart: "कार्ट",
    login: "लॉगिन",
    register: "रजिस्टर",
    logout: "लॉगआउट",
    dashboard: "डैशबोर्ड",
    profile: "प्रोफाइल",
    myOrders: "मेरे ऑर्डर",
    transactions: "लेनदेन",
    adminPanel: "एडमिन पैनल",
    
    // Common
    welcome: "स्वागत है",
    search: "खोजें",
    searchProducts: "उत्पाद खोजें...",
    loading: "लोड हो रहा है...",
    submit: "जमा करें",
    cancel: "रद्द करें",
    save: "सहेजें",
    edit: "संपादित करें",
    delete: "हटाएं",
    confirm: "पुष्टि करें",
    yes: "हाँ",
    no: "नहीं",
    
    // Wallet
    cashWallet: "कैश वॉलेट",
    commissionWallet: "कमीशन वॉलेट",
    addFunds: "पैसे जोड़ें",
    transfer: "ट्रांसफर",
    
    // Orders
    orderPlaced: "ऑर्डर दिया गया",
    orderPending: "स्वीकृति की प्रतीक्षा",
    orderApproved: "स्वीकृत",
    orderRejected: "अस्वीकृत",
    
    // Confirmation
    confirmPayment: "भुगतान की पुष्टि करें",
    confirmPaymentMsg: "क्या आप वाकई इस भुगतान के साथ आगे बढ़ना चाहते हैं?",
    doubleCheck: "पुष्टि करने से पहले दोबारा जांच लें",
  },
  mr: {
    // Navigation
    home: "मुख्यपृष्ठ",
    products: "उत्पादने",
    courses: "कोर्सेस",
    cart: "कार्ट",
    login: "लॉगिन",
    register: "नोंदणी",
    logout: "लॉगआउट",
    dashboard: "डॅशबोर्ड",
    profile: "प्रोफाइल",
    myOrders: "माझ्या ऑर्डर्स",
    transactions: "व्यवहार",
    adminPanel: "अ‍ॅडमिन पॅनेल",
    
    // Common
    welcome: "स्वागत आहे",
    search: "शोधा",
    searchProducts: "उत्पादने शोधा...",
    loading: "लोड होत आहे...",
    submit: "सादर करा",
    cancel: "रद्द करा",
    save: "जतन करा",
    edit: "संपादित करा",
    delete: "हटवा",
    confirm: "पुष्टी करा",
    yes: "होय",
    no: "नाही",
    
    // Wallet
    cashWallet: "कॅश वॉलेट",
    commissionWallet: "कमिशन वॉलेट",
    addFunds: "पैसे जोडा",
    transfer: "ट्रान्सफर",
    
    // Orders
    orderPlaced: "ऑर्डर दिला",
    orderPending: "मंजुरीच्या प्रतीक्षेत",
    orderApproved: "मंजूर",
    orderRejected: "नाकारले",
    
    // Confirmation
    confirmPayment: "पेमेंट पुष्टी करा",
    confirmPaymentMsg: "तुम्हाला खात्री आहे की तुम्ही या पेमेंटसह पुढे जाऊ इच्छिता?",
    doubleCheck: "पुष्टी करण्यापूर्वी पुन्हा तपासा",
  },
  ta: {
    home: "முகப்பு",
    products: "தயாரிப்புகள்",
    courses: "படிப்புகள்",
    cart: "வண்டி",
    login: "உள்நுழை",
    register: "பதிவு செய்",
    logout: "வெளியேறு",
    dashboard: "டாஷ்போர்டு",
    profile: "சுயவிவரம்",
    myOrders: "என் ஆர்டர்கள்",
    transactions: "பரிவர்த்தனைகள்",
    adminPanel: "நிர்வாக பேனல்",
    welcome: "வரவேற்கிறோம்",
    search: "தேடு",
    searchProducts: "தயாரிப்புகளைத் தேடு...",
    loading: "ஏற்றுகிறது...",
    submit: "சமர்ப்பி",
    cancel: "ரத்து செய்",
    save: "சேமி",
    edit: "திருத்து",
    delete: "நீக்கு",
    confirm: "உறுதிப்படுத்து",
    yes: "ஆம்",
    no: "இல்லை",
    cashWallet: "பண பணப்பை",
    commissionWallet: "கமிஷன் பணப்பை",
    addFunds: "பணம் சேர்",
    transfer: "பரிமாற்றம்",
    orderPlaced: "ஆர்டர் செய்யப்பட்டது",
    orderPending: "ஒப்புதலுக்காக காத்திருக்கிறது",
    orderApproved: "அங்கீகரிக்கப்பட்டது",
    orderRejected: "நிராகரிக்கப்பட்டது",
    confirmPayment: "கட்டணத்தை உறுதிப்படுத்து",
    confirmPaymentMsg: "இந்த கட்டணத்தை தொடர விரும்புகிறீர்களா?",
    doubleCheck: "உறுதிப்படுத்துவதற்கு முன் மீண்டும் சரிபார்க்கவும்",
  },
  te: {
    home: "హోమ్",
    products: "ఉత్పత్తులు",
    courses: "కోర్సులు",
    cart: "కార్ట్",
    login: "లాగిన్",
    register: "నమోదు",
    logout: "లాగ్అవుట్",
    dashboard: "డాష్‌బోర్డ్",
    profile: "ప్రొఫైల్",
    myOrders: "నా ఆర్డర్లు",
    transactions: "లావాదేవీలు",
    adminPanel: "అడ్మిన్ ప్యానెల్",
    welcome: "స్వాగతం",
    search: "వెతకండి",
    searchProducts: "ఉత్పత్తులను వెతకండి...",
    loading: "లోడ్ అవుతోంది...",
    submit: "సమర్పించు",
    cancel: "రద్దు",
    save: "సేవ్",
    edit: "సవరించు",
    delete: "తొలగించు",
    confirm: "నిర్ధారించు",
    yes: "అవును",
    no: "కాదు",
    cashWallet: "క్యాష్ వాలెట్",
    commissionWallet: "కమీషన్ వాలెట్",
    addFunds: "డబ్బు జోడించు",
    transfer: "బదిలీ",
    orderPlaced: "ఆర్డర్ చేయబడింది",
    orderPending: "ఆమోదం కోసం వేచి ఉంది",
    orderApproved: "ఆమోదించబడింది",
    orderRejected: "తిరస్కరించబడింది",
    confirmPayment: "చెల్లింపు నిర్ధారించు",
    confirmPaymentMsg: "మీరు ఖచ్చితంగా ఈ చెల్లింపుతో కొనసాగించాలనుకుంటున్నారా?",
    doubleCheck: "నిర్ధారించే ముందు మళ్లీ తనిఖీ చేయండి",
  },
  kn: {
    home: "ಮುಖಪುಟ",
    products: "ಉತ್ಪನ್ನಗಳು",
    courses: "ಕೋರ್ಸ್‌ಗಳು",
    cart: "ಕಾರ್ಟ್",
    login: "ಲಾಗಿನ್",
    register: "ನೋಂದಣಿ",
    logout: "ಲಾಗ್ಔಟ್",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    profile: "ಪ್ರೊಫೈಲ್",
    myOrders: "ನನ್ನ ಆರ್ಡರ್‌ಗಳು",
    transactions: "ವಹಿವಾಟುಗಳು",
    adminPanel: "ಅಡ್ಮಿನ್ ಪ್ಯಾನಲ್",
    welcome: "ಸ್ವಾಗತ",
    search: "ಹುಡುಕು",
    searchProducts: "ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ...",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
    submit: "ಸಲ್ಲಿಸು",
    cancel: "ರದ್ದುಮಾಡು",
    save: "ಉಳಿಸು",
    edit: "ಸಂಪಾದಿಸು",
    delete: "ಅಳಿಸು",
    confirm: "ದೃಢೀಕರಿಸು",
    yes: "ಹೌದು",
    no: "ಇಲ್ಲ",
    cashWallet: "ಕ್ಯಾಶ್ ವಾಲೆಟ್",
    commissionWallet: "ಕಮಿಷನ್ ವಾಲೆಟ್",
    addFunds: "ಹಣ ಸೇರಿಸು",
    transfer: "ವರ್ಗಾವಣೆ",
    confirmPayment: "ಪಾವತಿ ದೃಢೀಕರಿಸು",
    confirmPaymentMsg: "ಈ ಪಾವತಿಯೊಂದಿಗೆ ಮುಂದುವರೆಯಲು ನೀವು ಖಚಿತವಾಗಿದ್ದೀರಾ?",
    doubleCheck: "ದೃಢೀಕರಿಸುವ ಮೊದಲು ಮತ್ತೆ ಪರಿಶೀಲಿಸಿ",
  },
  bn: {
    home: "হোম",
    products: "পণ্য",
    courses: "কোর্স",
    cart: "কার্ট",
    login: "লগইন",
    register: "নিবন্ধন",
    logout: "লগআউট",
    dashboard: "ড্যাশবোর্ড",
    profile: "প্রোফাইল",
    myOrders: "আমার অর্ডার",
    transactions: "লেনদেন",
    adminPanel: "অ্যাডমিন প্যানেল",
    welcome: "স্বাগতম",
    search: "অনুসন্ধান",
    searchProducts: "পণ্য অনুসন্ধান করুন...",
    loading: "লোড হচ্ছে...",
    submit: "জমা দিন",
    cancel: "বাতিল",
    save: "সংরক্ষণ",
    edit: "সম্পাদনা",
    delete: "মুছুন",
    confirm: "নিশ্চিত করুন",
    yes: "হ্যাঁ",
    no: "না",
    cashWallet: "ক্যাশ ওয়ালেট",
    commissionWallet: "কমিশন ওয়ালেট",
    addFunds: "টাকা যোগ করুন",
    transfer: "ট্রান্সফার",
    confirmPayment: "পেমেন্ট নিশ্চিত করুন",
    confirmPaymentMsg: "আপনি কি নিশ্চিত যে আপনি এই পেমেন্ট করতে চান?",
    doubleCheck: "নিশ্চিত করার আগে দুবার চেক করুন",
  },
  gu: {
    home: "હોમ",
    products: "ઉત્પાદનો",
    courses: "અભ્યાસક્રમો",
    cart: "કાર્ટ",
    login: "લોગિન",
    register: "નોંધણી",
    logout: "લોગઆઉટ",
    dashboard: "ડેશબોર્ડ",
    profile: "પ્રોફાઇલ",
    myOrders: "મારા ઓર્ડર્સ",
    transactions: "વ્યવહારો",
    adminPanel: "એડમિન પેનલ",
    welcome: "સ્વાગત છે",
    search: "શોધો",
    searchProducts: "ઉત્પાદનો શોધો...",
    loading: "લોડ થઈ રહ્યું છે...",
    submit: "સબમિટ કરો",
    cancel: "રદ કરો",
    save: "સાચવો",
    edit: "સંપાદિત કરો",
    delete: "કાઢી નાખો",
    confirm: "પુષ્ટિ કરો",
    yes: "હા",
    no: "ના",
    cashWallet: "કેશ વોલેટ",
    commissionWallet: "કમિશન વોલેટ",
    addFunds: "પૈસા ઉમેરો",
    transfer: "ટ્રાન્સફર",
    confirmPayment: "ચુકવણીની પુષ્ટિ કરો",
    confirmPaymentMsg: "શું તમે ખરેખર આ ચુકવણી સાથે આગળ વધવા માંગો છો?",
    doubleCheck: "પુષ્ટિ કરતા પહેલા ફરીથી તપાસો",
  },
  pa: {
    home: "ਹੋਮ",
    products: "ਉਤਪਾਦ",
    courses: "ਕੋਰਸ",
    cart: "ਕਾਰਟ",
    login: "ਲੌਗਇਨ",
    register: "ਰਜਿਸਟਰ",
    logout: "ਲੌਗਆਉਟ",
    dashboard: "ਡੈਸ਼ਬੋਰਡ",
    profile: "ਪ੍ਰੋਫਾਈਲ",
    myOrders: "ਮੇਰੇ ਆਰਡਰ",
    transactions: "ਲੈਣ-ਦੇਣ",
    adminPanel: "ਐਡਮਿਨ ਪੈਨਲ",
    welcome: "ਜੀ ਆਇਆਂ ਨੂੰ",
    search: "ਖੋਜੋ",
    searchProducts: "ਉਤਪਾਦ ਖੋਜੋ...",
    loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
    submit: "ਜਮ੍ਹਾਂ ਕਰੋ",
    cancel: "ਰੱਦ ਕਰੋ",
    save: "ਸੇਵ ਕਰੋ",
    edit: "ਸੰਪਾਦਿਤ ਕਰੋ",
    delete: "ਮਿਟਾਓ",
    confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
    yes: "ਹਾਂ",
    no: "ਨਹੀਂ",
    cashWallet: "ਕੈਸ਼ ਵਾਲਿਟ",
    commissionWallet: "ਕਮਿਸ਼ਨ ਵਾਲਿਟ",
    addFunds: "ਪੈਸੇ ਜੋੜੋ",
    transfer: "ਟ੍ਰਾਂਸਫਰ",
    confirmPayment: "ਭੁਗਤਾਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
    confirmPaymentMsg: "ਕੀ ਤੁਸੀਂ ਯਕੀਨਨ ਇਸ ਭੁਗਤਾਨ ਨਾਲ ਅੱਗੇ ਵਧਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    doubleCheck: "ਪੁਸ਼ਟੀ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਦੁਬਾਰਾ ਜਾਂਚ ਕਰੋ",
  },
};

const languages = [
  { code: 'en', name: 'English', native: 'English' },
  { code: 'hi', name: 'Hindi', native: 'हिन्दी' },
  { code: 'mr', name: 'Marathi', native: 'मराठी' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు' },
  { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ' },
];

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations.en[key] || key;
  };

  const value = {
    language,
    setLanguage,
    t,
    languages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
